import type { ReactElement } from 'react'
import styled from 'styled-components'

import { LinkText } from '@/components/elements/LinkText'
import { SectionTitle } from '@/components/elements/SectionTitle'
import { Spacer } from '@/components/elements/Spacer'
import { TitleLayout } from '@/components/layout'
import { Head } from '@/components/layouts/Head'
import { Layout } from '@/components/layouts/Ir'
import { AHeading, BHeading, CHeading } from '@/components/layouts/Ir/Heading'
import { Paragraph } from '@/components/layouts/Ir/Paragraph'

export const OrganizationPage = () => {
  return (
    <Layout>
      <SectionTitle
        color="normal"
        titleText="Overview of Corporate Governance System"
        subTitleText="コーポレート・ガバナンス体制"
      />
      <Spacer h={{ sp: 70, pc: 120 }} />
      <section>
        <AHeading>企業統治の体制の概要及び当該体制を採用する理由</AHeading>
        <BHeading>企業統治体制の概要</BHeading>
        <Paragraph>
          当社は会社法上の機関として、株主総会、取締役会及び監査役会を設置しております。また機動的な業務執行を図るためマネジメントカンファレンスを設けております。さらにコーポレート・ガバナンスの充実のために、株主総会の充実、取締役会の一層の機能強化を図るとともに、各種諮問機関等を設けております。各機関の概要は以下のとおりです。
        </Paragraph>
        <Spacer h={{ sp: 30, pc: 50 }} />
        <CHeading>1. 取締役会</CHeading>
        <Paragraph>
          取締役会は、代表取締役社長永田洋幸が議長を務め、
          <LinkText path="/company/officer" text="役員一覧" />
          に記載されている全ての取締役で構成されており、毎月1回定期的に開催するほか必要に応じて臨時に開催しております。取締役会においては月次決算の報告及び会社法、取締役会規程に定められた事項に関する審議を行っております。業務執行の具体的内容や、その背景となる戦略検討及び重要事項の取組方針の審議が行われ、その結果に基づいて業務執行責任者が意思決定を行う仕組みとなっております。
        </Paragraph>
        <Spacer h={{ sp: 30, pc: 50 }} />
        <CHeading>2. 監査役会</CHeading>
        <Paragraph>
          監査役は、毎月開催される取締役会等の重要な会議に出席することにより、各取締役の業務遂行状況を確認するとともに、業務遂行における経営上遵守すべき各法律においてコンプライアンスがなされているか適宜適切な意見を表明することで、牽制機能を果たしております。
        </Paragraph>
        <Paragraph>
          監査役会は、常勤監査役上里剛志が議長を務め、
          <LinkText path="/company/officer" text="役員一覧" />
          に記載の全ての監査役で構成されております。経営の透明性の向上と経営監視機能の強化を図るため、非常勤監査役2名を社外監査役としております。各監査役は経営全般、会計、企業法務等において専門的知見、経験等を有し、また、非常勤監査役2名を独立役員として選任することで、当社の経営・業務執行の意思決定につき、経営監視機能の客観性及び中立性は十分に確保できると判断し現状の体制を採用しております。
        </Paragraph>
        <Spacer h={{ sp: 30, pc: 50 }} />
        <CHeading>3. 内部監査室</CHeading>
        <Paragraph>
          当社は事業部門から独立した内部監査室を設置しております。
        </Paragraph>
        <Paragraph>  
          また連結子会社である㈱トライアルカンパニーの内部監査室及び㈱西友の内部監査部を設置しており、合わせて15名（2026年6月末時点）で構成されております。内部監査に当たっては、年間計画に基づいて事業所と本社部門を対象に業務全般に亘って監査を行い、監査結果は書面により社長に報告され、併せて常勤監査役にも原則として月に1回情報共有をし、必要に応じて取締役会への報告も行っております。被監査部門に対しては監査結果に基づく改善指示を行い、改善状況を遅延なく報告させて確認を行っております。また、常勤監査役と監査課題等について適宜情報共有を図っております。
        </Paragraph>
        <Spacer h={{ sp: 30, pc: 50 }} />
        <CHeading>4. 会計監査人</CHeading>
        <Paragraph>
          当社は、PwC Japan有限責任監査法人と監査契約を締結し、適時適切な監査が実施されております。なお、同監査法人及び当社監査に従事する同監査法人の業務執行社員と当社との間には特別な利害関係はありません。
        </Paragraph>
        <Spacer h={{ sp: 30, pc: 50 }} />
        <CHeading>5. マネジメントカンファレンス</CHeading>
        <Paragraph>
          マネジメントカンファレンスは、代表取締役社長永田洋幸が議長を務め、常勤取締役、常勤監査役及び執行役員を中心として構成されており、迅速かつ効率的な意思決定を行うことを目的として、全社的に影響を及ぼす経営上の重要事項の審議・検討のほか、業績の進捗状況の確認及び各種重要連絡事項の共有等を行うものとして、毎月1回開催しております。
        </Paragraph>
        <Spacer h={{ sp: 30, pc: 50 }} />
        <CHeading>6. 投資諮問委員会</CHeading>
        <Paragraph>
          M&A、不動産取得、IT投資等の重要な投資案件を審議するため、取締役会の下に任意の諮問機関として投資諮問委員会を設置しております。委員会は、財務、経営企画、リスク管理等を管掌する執行役員で構成し、委員長は経営戦略部門を管掌する執行役員が務めております。重要な投資案件は、同委員会に事前に諮問し、その答申を最大限尊重して取締役会で決定しております。
        </Paragraph>
        <Spacer h={{ sp: 30, pc: 50 }} />
        <CHeading>7. 指名・報酬諮問委員会</CHeading>
        <Paragraph>
          経営陣幹部・役員の指名（後継者計画を含む）・報酬などに係る取締役会の機能の独立性・客観性と説明責任を強化するため、取締役会の下に任意の諮問機関として、独立社外取締役を過半数とし（常勤取締役1名（永田洋幸）、独立社外取締役2名（立本博文及び張相秀））、独立社外取締役張相秀を委員長とする指名・報酬諮問委員会を設置しております。経営陣幹部・役員の選解任及び報酬等は、同委員会に事前に諮問し、その答申を最大限尊重して取締役会で決定しております。
        </Paragraph>
        <Spacer h={{ sp: 30, pc: 50 }} />
        <CHeading>8. グループリスクコンプライアンス委員会</CHeading>
        <Paragraph>
          全社のリスク事象及びコンプライアンス事案の把握、重大なコンプライアンス事件・事故等の発生時における対応策等の検討など、リスク及びコンプライアンスに関する損失の最小化を目的として設置しており、原則として四半期に1回定例会議を開催するほか必要に応じて臨時に開催しております。
        </Paragraph>
        <Spacer h={{ sp: 30, pc: 50 }} />
        <CHeading>9. 情報セキュリティ委員会</CHeading>
        <Paragraph>
          情報セキュリティに関する全社検討及びセキュリティ事件・事故等の発生時における対応策等の検討を目的として設置しており、原則として毎年4回定例会議を開催しております。
        </Paragraph>
        <Spacer h={{ sp: 30, pc: 50 }} />
        <CHeading>10. ハラスメント委員会</CHeading>
        <Paragraph>
          ハラスメント案件の未然防止、案件の適切な対応・再発防止策の策定等を行うことを目的として設置しており、原則として毎週1回開催しております。
        </Paragraph>
        <Spacer h={{ sp: 30, pc: 50 }} />
        <CHeading>11. 懲罰委員会</CHeading>
        <Paragraph>
          従業員による不祥事等の発生に際し、その関係者等に対し懲戒処分を科すことの要否、及び処分の軽重に関する意思決定にあたり公正な取扱いを行うことを目的として設置しており、必要に応じ、委員長がこれを招集し適宜開催することとしております。
        </Paragraph>
        <Spacer h={{ sp: 30, pc: 50 }} />
        <CHeading>12. 関連当事者等取引検討委員会</CHeading>
        <Paragraph>
          関連当事者取引の事前把握並びに当該取引の必要性及び取引の妥当性を検証することを目的として設置しており、原則毎月1回開催しております。委員会はガバナンス部管掌役員を委員長とし、その他委員については取締役会の決議により選任された社外取締役又は監査役で構成することで、委員会の透明性を担保しています。
        </Paragraph>
        <Spacer h={{ sp: 30, pc: 50 }} />
        <Paragraph>
          会社の機関・内部統制の関係は以下のとおりであります。
        </Paragraph>
        <Spacer h={{ sp: 30, pc: 30 }} />
        <Image src="/images/TRIAL_Corporate_Governance_System_JA.png" alt="株主総会" width="100%" />
        <Spacer h={{ sp: 50, pc: 80 }} />
        <BHeading>企業統治の体制を採用する理由</BHeading>
        <Paragraph>
          当社は、経営体制の透明性を確保するとともに、コーポレート・ガバナンスのより一層の充実・強化を図ることを目的として、2021年9月に監査役会設置会社に移行いたしました。2026年9月24日現在において、取締役4名のうち、2名を社外取締役とすることにより、各専門分野における客観的な立場からの助言・提言を受けるとともに、取締役会の監督機能の強化を図っております。また、監査役3名のうち、2名を社外監査役とすることで経営監視機能の客観性、中立性を確保しております。これらに加え、社外取締役が過半数で構成される指名・報酬諮問委員会や、社内の取締役、監査役及び執行役員を中心とした経営会議体「マネジメントカンファレンス」を設置することにより、経営の透明性を確保しつつ、迅速な意思決定によるスピード経営が実現できる体制を構築しております。
        </Paragraph>
      </section>
    </Layout>
  )
}

OrganizationPage.getLayout = (page: ReactElement) => {
  const breadCrumbs = [
    { name: 'ホーム', path: '/' },
    { name: '株主・投資家向け情報', path: '/ir/' },
    { name: 'コーポレート・ガバナンス', path: '/ir/governance/' },
    { name: 'コーポレート・ガバナンス体制', path: '' },
  ]

  return (
    <>
      <Head
        title="コーポレート・ガバナンス体制"
        description="トライアルホールディングスの企業統治体制の概要と当該体制を採用する理由について掲載しています。"
        ogp={{ url: 'ir/governance/organization/' }}
      />
      <TitleLayout
        title="Investor Relations"
        subTitle="株主・投資家向け情報"
        breadCrumbs={breadCrumbs}
      >
        {page}
      </TitleLayout>
    </>
  )
}

const Image = styled.img`
  height: 100%;
`
